import {
    HStack,
    VStack,
    Box,
    IconButton,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    MenuDivider,
    Icon,
    Text,
    StackProps,
} from '@chakra-ui/react';
import { HiOutlineDotsVertical } from 'react-icons/hi';
import { BsPlus } from 'react-icons/bs';
import { BlockItemViewProps } from '../../../../view';
import { ReportingViewBaseConfig } from '../../../../base';

export type DocumentBlockItemViewProps = BlockItemViewProps & {
    as?: React.ReactElement<StackProps>;
};

export function createDocumentItemView(
    config: ReportingViewBaseConfig
): React.FC<DocumentBlockItemViewProps> {
    return (props) => {
        return (
            <HStack
                w="full"
                align="start"
                role="group"
                mt={4}
                spacing={3}
                onMouseMove={props.onMouseMove}
                {...props.as?.props}
            >
                <Menu placement="left" boundary="clippingParents" autoSelect={false}>
                    <MenuButton
                        flexShrink={0}
                        color="whiteAlpha.500"
                        as={IconButton}
                        size="sm"
                        h={6}
                        w={6}
                        minW={0}
                        minH={0}
                        variant="outline"
                        bg="none"
                        icon={<Icon fontSize="lg" as={HiOutlineDotsVertical} />}
                        opacity={0}
                        transition="opacity 0.2s ease-in-out"
                        _focus={{ outline: 'none' }}
                        _hover={{ bg: 'whiteAlpha.50' }}
                        _expanded={{ bg: 'whiteAlpha.100', opacity: 1 }}
                        _groupHover={{
                            opacity: props.menu.isVisible ? 1 : 0,
                        }}
                    />
                    <MenuList minW="16rem" bg="black" p={0} overflow="hidden">
                        <VStack
                            align="start"
                            w="full"
                            bg="whiteAlpha.200"
                            p={1}
                            spacing={0}
                        >
                            {props.menu.items.map((item, index) => {
                                if (item.kind === 'divider') {
                                    return (
                                        <MenuDivider
                                            key={index}
                                            my={1}
                                            bg="whiteAlpha.100"
                                            borderColor="whiteAlpha.200"
                                            w="full"
                                        />
                                    );
                                }
                                return (
                                    <MenuItem
                                        key={item.id}
                                        borderRadius="md"
                                        py={1}
                                        fontSize="sm"
                                        fontWeight="medium"
                                        color="whiteAlpha.800"
                                        icon={
                                            item.Icon ? (
                                                <Icon fontSize="lg" as={item.Icon} />
                                            ) : undefined
                                        }
                                        _hover={{
                                            bg: 'whiteAlpha.50',
                                            color: item.colorScheme
                                                ? `${item.colorScheme}.400`
                                                : undefined,
                                        }}
                                        {...item.button}
                                    >
                                        {item.description}
                                    </MenuItem>
                                );
                            })}
                            <MenuDivider
                                my={1}
                                bg="whiteAlpha.100"
                                borderColor="whiteAlpha.200"
                                w="full"
                            />
                            <MenuItem
                                py={1}
                                borderRadius="md"
                                userSelect="none"
                                color="whiteAlpha.500"
                                cursor="default"
                                _hover={{ bg: 'none' }}
                                fontSize="xs"
                            >
                                <VStack align="start" w="full" spacing={0}>
                                    <Text>Last edited by Susie</Text>
                                    <Text>Apr 17, 2025, 9:30 AM</Text>
                                </VStack>
                            </MenuItem>
                        </VStack>
                    </MenuList>
                </Menu>
                {props.insert && (
                    <Menu>
                        <MenuButton
                            aria-label="floating-menu"
                            as={IconButton}
                            icon={<Icon fontSize="xl" as={BsPlus} />}
                            color="whiteAlpha.400"
                            size="xs"
                            borderRadius="full"
                            bg="whiteAlpha.200"
                            _hover={{ bg: 'whiteAlpha.300' }}
                            _expanded={{ bg: 'whiteAlpha.400' }}
                            _focus={{ outline: 'none' }}
                        />
                        <MenuList minW="16rem" bg="black" p={0} overflow="hidden">
                            <VStack
                                align="start"
                                w="full"
                                bg="whiteAlpha.200"
                                p={1}
                                spacing={0}
                            >
                                {props.insert.menu.items.map((item, index) => {
                                    if (item.kind === 'divider') {
                                        return (
                                            <MenuDivider
                                                key={`divider-${index}`}
                                                my={1}
                                                bg="whiteAlpha.100"
                                                borderColor="whiteAlpha.200"
                                                w="full"
                                            />
                                        );
                                    }
                                    return (
                                        <MenuItem
                                            key={item.id}
                                            borderRadius="md"
                                            py={1}
                                            fontSize="sm"
                                            fontWeight="medium"
                                            color="whiteAlpha.800"
                                            icon={
                                                item.Icon ? (
                                                    <Icon fontSize="lg" as={item.Icon} />
                                                ) : undefined
                                            }
                                            _hover={{
                                                bg: 'whiteAlpha.50',
                                                color: item.colorScheme
                                                    ? `${item.colorScheme}.400`
                                                    : undefined,
                                            }}
                                            {...item.button}
                                        >
                                            {item.label}
                                        </MenuItem>
                                    );
                                })}
                            </VStack>
                        </MenuList>
                    </Menu>
                )}
                <Box flexGrow={1} position="relative">
                    {props.children}
                </Box>
            </HStack>
        );
    };
}
